import { useQuery } from "@tanstack/react-query";
import { fetchPost, fetchPosts } from "@/lib/api/posts";

export function usePosts(published = true) {
  return useQuery({
    queryKey: ["posts", published],
    queryFn: () => fetchPosts(published),
  });
}

export function usePost(slug: string | undefined) {
  return useQuery({
    queryKey: ["post", slug],
    queryFn: () => fetchPost(slug ?? ""),
    enabled: Boolean(slug),
  });
}
